<form class="form-horizontal" [formGroup]="pageForm">
  <div class="row ms-4 py-3">
    <button
      *ngIf="displayBackButton"
      type="button"
      class="btn bottom-btn btn-primary float-start px-3"
      (click)="returnToSearchCriteria()"
    >
      <span class="arrow left float-start">
        <i class="fa fa-chevron-left"></i> </span
      ><span class="float-end">{{ pageText?.lbl_return }}</span>
    </button>
    <div *ngIf="displayBackButton" class="clearfix"></div>
  </div>
  <div
    *ngFor="let error of errorsList"
    class="alert alert-danger text-center"
    role="alert"
  >
    {{ error }}
  </div>
  <div class="card-body mb-5">
    <h6 class="ps-3 pt-2">
      {{ pageText?.subtext }}
      <a href="https://www.azdeq.gov/records" target="_blank"><u>LINK</u> ></a>
    </h6>

    <table
      class="h6 table table-striped mt-4"
      [mfData]="model?.releaseDetails"
      #mf="mfDataTable"
      [mfRowsOnPage]="15"
      mfSortOrder="desc"
    >
      <thead>
        <tr>
          <th>
            {{ pageText?.lbl_case }}
          </th>
          <th>
            {{ pageText?.lbl_confirm_dt }}
          </th>
          <th>
            {{ pageText?.lbl_status }}
          </th>
          <th>
            {{ pageText?.lbl_fac }}
          </th>
          <th>
            {{ pageText?.lbl_fac_nm }}
          </th>
          <th>
            {{ pageText?.lbl_address }}
          </th>
          <th>
            {{ pageText?.lbl_county }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let record of mf.data">
          <td>{{ record?.display_ustcase }}</td>
          <td>{{ record?.confirmedDt }}</td>
          <td>{{ record?.status }}</td>
          <td>{{ record?.facilityId }}</td>
          <td
            placement="top"
            [ngbPopover]="record?.facName"
            container="body"
            triggers="mouseenter:mouseleave"
          >
            {{ record?.facName | concatString : 25 }}
          </td>
          <td
            placement="top"
            [ngbPopover]="record?.display_address"
            container="body"
            triggers="mouseenter:mouseleave"
          >
            {{ record?.display_address | concatString : 25 }}
          </td>
          <td>{{ record?.county }}</td>
        </tr>
        <!-- <tr *ngIf="noRecordsFound">
                    <td colspan="8" class="text-center py-3">
                        <span class="fw-light">
                            Based on the search criteria provided, there are no search results. Please refine
                            your search.
                        </span>
                    </td>
                </tr> -->
      </tbody>
      <tfoot>
        <tr>
          <td [attr.colspan]="8" class="pb-0 mb-0 ps-0">
            <div class="pb-0 mb-0">
              <mfBootstrapPaginator></mfBootstrapPaginator>
              <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
          </td>
        </tr>
      </tfoot>
    </table>

    <div class="mt-4 h5 ms-3">
      <div class="row">
        <div class="col-md-6">
          <div class="row mt-3">
            <div class="col-md-6">{{ pageText?.lbl_rel_report_date }}</div>
            <div class="col-md-6 ps-0 fw-light">
              {{
                releaseDetails?.reportedDate
                  ? releaseDetails?.reportedDate
                  : "-"
              }}
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-6">
              {{ pageText?.lbl_product_discovery_date }}
            </div>
            <div class="col-md-6 ps-0 fw-light">
              {{
                releaseDetails && releaseDetails?.fpDiscoveryDate
                  ? releaseDetails?.fpDiscoveryDate
                  : "-"
              }}
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-4">{{ pageText?.lbl_dept_to_water }}</div>
            <div class="col-md-8 ps-0 fw-light">
              {{
                releaseDetails && releaseDetails?.depthWtrDesc
                  ? releaseDetails?.depthWtrDesc
                  : "-"
              }}
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-4">{{ pageText?.lbl_priority }}</div>
            <div class="col-md-8 ps-0 fw-light">
              {{ releaseDetails?.priorityType }} -
              {{ releaseDetails?.priorityDesc }}
            </div>
            <!-- <div class="col-md-8 ps-0 fw-light">
                            {{releaseDetails && releaseDetails?.priorityType ? releaseDetails?.priorityType :
                            '-'}} - {{releaseDetails && releaseDetails?.priorityDesc ? releaseDetails?.priorityDesc :
                            '-'}}
                        </div> -->
          </div>
          <div class="row mt-3">
            <div class="col-md-4">{{ pageText?.lbl_classification }}</div>
            <div class="col-md-8 ps-0 fw-light">
              {{
                releaseDetails && releaseDetails?.classDesc
                  ? releaseDetails?.classDesc
                  : "-"
              }}
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row mt-3">
            <div class="col-md-6">{{ pageText?.lbl_char_date }}</div>
            <div class="col-md-6 ps-0 fw-light">
              {{
                releaseDetails && releaseDetails?.soilCharDate
                  ? releaseDetails?.soilCharDate
                  : "-"
              }}
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-6">{{ pageText?.lbl_case_closure_date }}</div>
            <div class="col-md-6 ps-0 fw-light">
              {{
                releaseDetails && releaseDetails?.closureDate
                  ? releaseDetails?.closureDate
                  : "-"
              }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <table
      class="h5 table table-striped mt-4"
      [mfData]="model?.products"
      #mf1="mfDataTable"
      [mfRowsOnPage]="15"
      mfSortOrder="desc"
    >
      <thead>
        <tr>
          <th>
            {{ pageText?.col_prod }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let record of mf1.data">
          <td>{{ record }}</td>
        </tr>
      </tbody>
    </table>

    <table
      class="h5 table table-striped mt-4"
      [mfData]="model?.mediasImpacted"
      #mf2="mfDataTable"
      [mfRowsOnPage]="15"
      mfSortOrder="desc"
    >
      <thead>
        <tr>
          <th>
            {{ pageText?.col_media }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let record of mf2.data">
          <td>{{ record }}</td>
        </tr>
      </tbody>
    </table>

    <div class="col-md-6 h5 mt-4">
      {{ pageText?.lbl_remed }}
    </div>
    <table
      class="h5 table table-striped"
      [mfData]="model?.remDetails"
      #mf3="mfDataTable"
      [mfRowsOnPage]="15"
      mfSortOrder="desc"
    >
      <thead>
        <tr>
          <th>
            {{ pageText?.col_med }}
          </th>
          <th>
            {{ pageText?.col_rem_method_cat }}
          </th>
          <th>
            {{ pageText?.col_rem_method_sub_cat }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let record of mf3.data">
          <td>{{ record?.mediaDesc }}</td>
          <td>{{ record?.remDesc }}</td>
          <td>{{ record?.remSubDesc }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</form>
